import React, { useMemo, useState } from 'react';
import RegistrationStep2 from './Step2/RegistrationStep2';
import RegistrationStep3 from './Step3/RegistrationStep3';
import RegistrationStep4 from './Step4/RegistrationStep4';

const REGISTRATION_STEP = [RegistrationStep2, RegistrationStep3, RegistrationStep4];

const SignUp = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [loginValue, setLoginValue] = useState('');
  const [sendVia, setSendVia] = useState('');

  const Content = useMemo(() => REGISTRATION_STEP[activeStep], [activeStep]);

  return (
    <div className="registration">
      <Content
        handleStep={setActiveStep}
        loginValue={loginValue}
        setLoginValue={setLoginValue}
        sendVia={sendVia}
        setSendVia={setSendVia}
      />
    </div>
  );
};

export default SignUp;
